import { PAGES_MAX, PAGES_MIN } from '../constants';

export const required = error => value => (value ? undefined : error);

export const email = error => value => {
  const emailRegExp =
    /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

  return emailRegExp.test(value) ? undefined : error;
};

export const integer = error => value => {
  const num = parseFloat(value);

  return typeof num === 'number' && Number.isFinite(num) && Math.floor(num) === num
    ? undefined
    : error;
};

export const positive = error => value => (parseInt(value, 10) > 0 ? undefined : error);

/**
 * @param {String} error
 * @param {Object} options
 * @param {Number} options.min
 * @param {Number} options.max
 * @returns {function(*=): boolean}
 */
export const range =
  (error, options = {}) =>
  value => {
    const { min = PAGES_MIN, max = PAGES_MAX } = options;

    return parseInt(value, 10) >= min && parseInt(value, 10) <= max ? undefined : error;
  };

export const moreThan =
  (error, n = PAGES_MIN) =>
  value =>
    parseInt(value, 10) >= n ? undefined : error;

export const lessThan =
  (error, n = PAGES_MAX) =>
  value =>
    parseInt(value, 10) <= n ? undefined : error;

/**
 * @param {Object} meta
 * @param {String|undefined} meta.error
 * @param {String|undefined} meta.submitError
 * @param {boolean|undefined} meta.dirtySinceLastSubmit
 * @param {boolean} meta.touched
 */
export const isError = meta =>
  meta.touched && (meta.error || (meta.submitError && !meta.dirtySinceLastSubmit));

/**
 * @param {Object} formState
 * @param {boolean} formState.hasSubmitErrors
 * @param {boolean} formState.submitting
 * @param {boolean} formState.dirtySinceLastSubmit
 * @param {string|undefined} formState.submitError
 */
export const isFormError = formState =>
  formState.hasSubmitErrors &&
  !formState.submitting &&
  !formState.dirtySinceLastSubmit &&
  formState.submitError;

/**
 * @param {Object} meta
 * @param {String|undefined} meta.submitError
 * @param {Boolean|undefined} meta.touched
 * @returns {String|boolean}
 */
export const isSubmitError = meta => meta.submitFailed && (meta.error || meta.submitError);

/**
 * do not rely on meta.valid
 * @see https://github.com/final-form/final-form/blob/672d02c56ef4a4048c9839b7d77161883c17793e/src/FinalForm.js#L548
 * @param {string} value
 * @param {Object} meta
 * @returns {boolean}
 */
export const isValid = (value, meta) =>
  meta.touched && (!meta.error || (!meta.submitError && meta.dirtySinceLastSubmit));

export const hasSpaces = error => value => {
  if (typeof value === 'string' || typeof value === 'number') {
    const isSpace = String(value).match(/\s/g);
    if (!isSpace) return undefined;
  }

  return error;
};

export const equal = error => a => b => (a === b ? undefined : error);

/**
 * @param {String} error
 * @param {Number} length min length
 **/
export const lengthMore = (error, length) => value => (value?.length >= length ? undefined : error);

/**
 * @param {String} error
 * @param {Number} length max length
 **/
export const lengthLess = (error, length) => value => (value?.length <= length ? undefined : error);

export const isContainNumber = error => value => (/[a-zA-Z]+/g.test(value) ? undefined : error);

export const isContainLetter = error => value =>
  /[\d!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/.test(value) ? undefined : error;

export const onlyText = error => value => (/^[A-Za-z\s]*$/.test(value) ? undefined : error);
